import api from '../resources/privilege-templates.api';
import actionTypes from './action-types';

export const createPrivilegeTemplateRequest = () => ({
  type: actionTypes.CREATE_PRIVILEGE_TEMPLATE_REQUEST,
});

export const createPrivilegeTemplateSuccess = (template) => ({
  type: actionTypes.CREATE_PRIVILEGE_TEMPLATE_SUCCESS,
  template,
});

export const createPrivilegeTemplateFailure = () => ({
  type: actionTypes.CREATE_PRIVILEGE_TEMPLATE_FAILURE,
});

export const createPrivilegeTemplate = (payload) => async (dispatch) => {
  try {
    dispatch(createPrivilegeTemplateRequest());

    const template = await api.createPrivilegeTemplate(payload);
    dispatch(createPrivilegeTemplateSuccess(template));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('CREATE_PRIVILEGE_TEMPLATE', error);
    dispatch(createPrivilegeTemplateFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/privilege-templates/actions/create-privilege-templates.actions.js